import { useContractQuery } from './useContractQuery';

/* -------------------------------------------------------------- *
 *   Auditor identity (AR v2-backed)
 * -------------------------------------------------------------- *
 *
 *   v3 removed the legacy single-wallet auditor pool. Auditors are
 *   firms registered in AuditorRegistryV2. Use this hook to find out
 *   whether a wallet is an active auditor — internally it delegates
 *   to the registry. For richer firm data (seniority, categories,
 *   reputation) use the dedicated useAuditorRegistry hooks.
 */

export function useIsActiveAuditor(address: string | null | undefined) {
  return useContractQuery<boolean>(
    ['auditingPool', 'isActiveAuditor', address ?? '0x0'],
    { enabled: !!address }
  );
}

export function useIsAuditorFor(
  reqId: number | bigint | null | undefined,
  address: string | null | undefined
) {
  return useContractQuery<boolean>(
    ['auditingPool', 'isAuditorFor', BigInt(reqId ?? 0), address ?? '0x0'],
    { enabled: !!address && reqId !== null && reqId !== undefined }
  );
}
